/**
 * Update Store Credit Limit Use Case
 * حالة الاستخدام لتحديث حد الائتمان للمتجر
 */

import {CreditRepository} from '../repository/CreditRepository';
import {Store} from '../../stores/models/store.model';

export class UpdateStoreCreditLimitUseCase {
  constructor (private creditRepository: CreditRepository) {}

  /**
   * تحديث حد الائتمان للمتجر
   */
  async execute (
    storeId: number,
    payload: { credit_limit: number; reason?: string }
  ): Promise<Store> {
    // Validate storeId
    if (!storeId || storeId <= 0) {
      throw new Error('معرف المتجر غير صحيح');
    }

    // Validate credit_limit
    if (payload.credit_limit < 0) {
      throw new Error('يجب أن يكون حد الائتمان أكبر من أو يساوي صفر');
    }

    // Call repository
    return await this.creditRepository.updateCreditLimit(storeId, payload);
  }
}
